var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"c-auth-page__head"},[_c('h1',[_vm._v(_vm._s(_vm.$t('h1')))])]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_vm._v("Происходит переход в личный кабинет")]),_c('p',[_vm._v("Пожалуйста, подождите...")])])
}]

export { render, staticRenderFns }